<template>
  <div class="row justify-content-center">
    <div class="col-12 col-lg-10">
      <div class="row" v-if="category === 'premium'">
        <PremiumRosesList />
      </div>
      <div class="row row-cols-2 row-cols-lg-4" v-else-if="category === 'dyed'">
        <div
          class="col"
          v-for="rose in dyedRoses"
          :key="rose.id"
          id="rose-col"
          v-show="
            visible(
              rose.color,
              rose.length,
              rose.vaselife
            )
          "
        >
          <RoseComponent
            :rose-name="rose.name"
            :length="rose.length"
            :bloom="rose.bloom"
            :petals="rose.petals"
            :vaselife="rose.vaselife"
            :img="require(`../assets/roses/` + rose.img)"
          />
        </div>
      </div>
      <div class="row row-cols-2 row-cols-lg-4" v-else-if="category === 'garden'">
        <div 
          class="col"
          v-for="rose in gardenRoses"
          :key="rose.id"
          id="rose-col"
          v-show="
            visible(
              rose.color,
              rose.length,
              rose.vaselife
            )
          "
        >
          <RoseComponent
            :rose-name="rose.name"
            :length="rose.length"
            :bloom="rose.bloom"
            :petals="rose.petals"
            :vaselife="rose.vaselife"
            :img="require(`../assets/roses/` + rose.img)"
          />
        </div>
      </div>
      <div class="row row-cols-2 row-cols-lg-4" v-else-if="category === 'group'"> 
        <div
          class="col"
          v-for="rose in groupRoses"
          :key="rose.id"
          id="rose-col"
          v-show="
            visible(
              rose.color,
              rose.length,
              rose.vaselife,
              rose.petals,
              rose.bloom
            )
          "
        >
          <RoseComponent
            :rose-name="rose.name"
            :length="rose.length"
            :bloom="rose.bloom"
            :petals="rose.petals"
            :vaselife="rose.vaselife"
            :img="require(`../assets/roses/` + rose.img)"
          />
        </div>
      </div>
      <div class="row justify-content-center" v-else-if="category === 'perpetual'">
        <PerpetualRosesList />
      </div>
      <div class="row justify-content-center" v-else-if="category === 'other'">
        <OtherRosesList />
      </div>
    </div>
  </div>
</template>

<script>
import RoseComponent from "./RoseComponent.vue";
import PerpetualRosesList from "./PerpetualRosesList.vue"
import PremiumRosesList from "./PremiumRosesList.vue";
import OtherRosesList from "./OtherRosesList.vue";
import dyedRosesArray from "../data/dyed-roses.json";
import gardenRosesArray from "../data/garden-roses.json";
import groupRosesArray from "../data/group-roses.json";
export default {
  name: "RosesListComponent",
  inject: ["checked"],
  components: {
    RoseComponent,
    PremiumRosesList,
    PerpetualRosesList,
    OtherRosesList
},
  data() {
    return {
      dyedRoses: dyedRosesArray,
      gardenRoses: gardenRosesArray,
      groupRoses: groupRosesArray
    };
  },
  props: {
    category: String,
  },
  methods: {
    visible: function (color, length, vaselife) {
      var isInColor = 0;
      var isInLength = 0;
      var isInVaselife = 0;
      function checkDifference(difference, lastTwo, currentLength) {
        var iteration = difference / 10;
        for (var j = 0; j < iteration; j++) {
          if (lastTwo - difference == currentLength) {
            isInLength = 1;
          }
          difference = difference - 10;
        }
      }

      for (var i = 0; i < this.checked.color.length; i++) {
        if (color == this.checked.color[i]) {
          isInColor = 1;
        }
      }

      for (i = 0; i < this.checked.lengths.length; i++) {
        if (typeof length == "string") {
          var firstTwo = length.substring(0, 2);
          var lastTwo = length.substring(3);
          var difference = lastTwo - firstTwo;
          if (firstTwo == this.checked.lengths[i]) {
            isInLength = 1;
          } else if (lastTwo == this.checked.lengths[i]) {
            isInLength = 1;
          } else if (difference > 10) {
            checkDifference(difference, lastTwo, this.checked.lengths[i]);
          }
        }
      }

      for (i = 0; i < this.checked.vaselife.length; i++) {
        if (vaselife == this.checked.vaselife[i]) {
          isInVaselife = 1;
        }
      }

      const lengths = this.checked.lengths.length ? isInLength : true;
      const colors = this.checked.color.length ? isInColor : true;
      const vaselifes = this.checked.vaselife.length ? isInVaselife : true;

      if (colors && lengths && vaselifes) {
        return true;
      } else {
        return false;
      }
    },
  }
};
</script>

<style>
#rose-col {
  margin-bottom: 5em !important;
}

@media only screen and (max-device-width: 812px) {
  #rose-col {
    margin-bottom: 2em !important;
  }
}
</style>
